module.exports = __webpack_public_path__ + "img/nextauction-image.8ffd696e.png";